export enum ActionTypes {
  TeammateRequestAccess = 'teammateRequestAccess',
  TeammateRequestAccessRequest = 'teammateRequestAccess.request',
  TeammateRequestAccessSuccess = 'teammateRequestAccess.success',
  TeammateRequestAccessFailure = 'teammateRequestAccess.failure',
  ClearTeammateRequestAccess = 'clearTeammateRequestAccess',
}
